<template>
  <Form :title="title" :description="description" :handlePrevious="decrementIndex">
    <InputField
      label="Email"
      type="email"
      placeholder="rick.sanchez@pm.me"
      :value="email"
      @input="$event => setEmail($event.target.value)"
    />
  </Form>
</template>

<script>
import Form from '@/components/Form';
import InputField from '@/components/InputField';
import useIndex from '@/composition/useIndex';
import useField from '@/composition/useField';

export default {
  name: 'ContactForm',
  components: {
    Form,
    InputField
  },
  props: {
    title: String,
    description: String
  },
  setup() {
    const { decrementIndex } = useIndex();
    const [email, setEmail] = useField('email');

    return {
      decrementIndex,
      email,
      setEmail
    };
  }
};
</script>
